import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  formatNumberWithDots,
  getToken,
  getTokenExpiration,
  logOut,
} from '../../helpers/utils'
import { getInfo } from '../../redux/reducers/userReducer'
import { AppDispatch, useAppDispatch } from '../../redux/store'
import { useNavigate } from 'react-router-dom'

interface Info {
  credits: {
    url: number
    qr: number
  }
  domains: string[]
  hasQrCredits: boolean
  hasUrlCredits: boolean
  plan: string
}

const AccountDetails = () => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const [userInfo, setUserInfo] = useState<Info>()
  const sessionExpired = getTokenExpiration()
  let navigate = useNavigate()

  useEffect(() => {
    if (sessionExpired) logOut()
  }, [sessionExpired])

  useEffect(() => {
    getUserInfo()
  }, [])

  const getUserInfo = async () => {
    const token = getToken()
    try {
      const { payload } = await dispatch(
        getInfo({
          token: token,
        })
      )
      if (payload?.success) {
        setUserInfo(payload?.data)
      } else {
        console.error(`${t('ERROR')}`)
      }
    } catch (error) {
      console.error('Error:', error)
    }
  }

  return (
    <>
      <div>
        <span className='principal-title'>{`${t('ACCOUNT_DETAILS')}`}</span>
        {userInfo && (
          <div>
            <div className='container-titles'>
              <span className='sub-title'>{`${t('CREDITS')}`}</span>
              <span className='sub-title-settings color-grey-dark'>{`${t(
                'CREDITS_URL'
              )}`}</span>
              <p className='title-bold'>
                {formatNumberWithDots(userInfo?.credits.url)}
              </p>
              <span className='sub-title-settings color-grey-dark'>{`${t(
                'CREDITS_QR'
              )}`}</span>
              <p className='title-bold'>
                {formatNumberWithDots(userInfo?.credits.qr)}
              </p>
            </div>
            <div className='container-titles'>
              <span className='sub-title'>{`${t('DOMAINS')}`}</span>

              {userInfo?.domains.map((item, index) => {
                return (
                  <p className={'bold'} key={`${index}-${item}`}>
                    {item}
                  </p>
                )
              })}

              <span className='sub-title'>{`${t('PLAN')}`}</span>
              <p>{`${
                userInfo ? t(userInfo?.plan.toLocaleUpperCase()) : ''
              }`}</p>
            </div>
          </div>
        )}
        <button
          className='button-first width-200'
          type='button'
          onClick={() => navigate('/plans')}
        >
          {`${t('UPDATE_PLAN')}`}
        </button>
      </div>
    </>
  )
}

export default AccountDetails
